import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { useSelector } from 'react-redux';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DistrictLocationsAccordion } from 'views/rebranded-module/location-module/LocationsViewV2/components';
import { FILTER_TYPE } from 'views/rebranded-module/location-module/LocationsViewV2/utils/constants';
import StyledBox from 'views/rebranded-module/location-module/LocationsViewV2/components/MobileLocationList/MobileLocationList.styles';
import { Typography700 } from 'views/rebranded-module/common/components';

const MobileLocationList = (props) => {
  const {
    usCountry,
    filteredUsLocations,
    filteredNonUsLocations,
    filter,
    expandAccordion,
    defaultVehicleType,
    content,
  } = props;
  const showMembership = useSelector(
    (state) => state.globalData.showMembership,
  );
  const shouldRemoveBg = () => filter === FILTER_TYPE.INTERNATIONAL
    || (filter !== FILTER_TYPE.ALL_LOCATIONS && filter !== FILTER_TYPE.CLUB);
  return (
    <StyledBox className="showMOBIL">
      {(filter === FILTER_TYPE.ALL_LOCATIONS
        || filter === FILTER_TYPE.CLUB
        || filter === FILTER_TYPE.US)
        && filteredUsLocations.length > 0 && (
          <Accordion
            square
            TransitionProps={{ unmountOnExit: true }}
            className="MLLDistrictAccordion"
            defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="MLSummary">
              <NavigatorLink
                href={PATHS.geoSlug([defaultVehicleType.slug, usCountry.slug])}>
                <Typography700
                  variant="h3"
                  component="p"
                  className="DLAbigLocation">
                  {usCountry.name}
                </Typography700>
              </NavigatorLink>
            </AccordionSummary>
            <AccordionDetails className="MLLDistrictAccordionDetails">
              {filteredUsLocations.map((location) => (
                <DistrictLocationsAccordion
                  isSearching={expandAccordion}
                  district={location}
                  membershipEnabled={showMembership}
                  key={location.slug}
                  defaultVehicleType={defaultVehicleType}
                  content={content}
                />
              ))}
            </AccordionDetails>
          </Accordion>
      )}

      {(filter === FILTER_TYPE.ALL_LOCATIONS
        || filter === FILTER_TYPE.CLUB
        || filter === FILTER_TYPE.INTERNATIONAL)
        && filteredNonUsLocations.length > 0 && (
          <Accordion
            className={`MLLDistrictAccordion MLLInternational ${
              shouldRemoveBg() ? 'MLRemoveBg' : ''
            }`}
            TransitionProps={{ unmountOnExit: true }}
            expanded={expandAccordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="MLSummary">
              <Typography700
                variant="h3"
                component="p"
                className="DLAbigLocation">
                {content.internationalLocations}
              </Typography700>
            </AccordionSummary>
            <AccordionDetails className="MLLDistrictAccordionDetails">
              {filteredNonUsLocations.map((location) => (
                <DistrictLocationsAccordion
                  expanded={expandAccordion}
                  district={location}
                  membershipEnabled={showMembership}
                  key={location.slug}
                  defaultVehicleType={defaultVehicleType}
                  content={content}
                />
              ))}
            </AccordionDetails>
          </Accordion>
      )}
    </StyledBox>
  );
};

export { MobileLocationList };
